import { render, staticRenderFns } from "./VerticalSelector.vue?vue&type=template&id=05ef58d8&"
import script from "./VerticalSelector.vue?vue&type=script&lang=js&"
export * from "./VerticalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports